import {dataTestId} from '@hconnect/uikit'
import {Skeleton} from '@mui/material'

import {PlannerSkeleton} from './PlannerSkeleton'
import {StockPageLayout} from './StockPageLayout'

export const PlannerPageLayout = () => {
  return (
    <StockPageLayout
      {...dataTestId('planner_page_skeleton')}
      title={
        <Skeleton
          variant="text"
          sx={{width: (theme) => theme.spacing(50), bgcolor: 'background.paper'}}
        />
      }
    >
      <PlannerSkeleton height="65vh" />
    </StockPageLayout>
  )
}
